<template>
  <div>
    <!-- 不良品状态列表 -->
    <el-dialog :visible.sync="dialogVisible" width="1600px" :title="title">
      <div class="table">
        <ol>

          <!-- 订单号 -->
          <li class="flex2">
            {{ $t('message.orderNumber') }}
          </li>
          <!-- 番号 -->
          <li class="flex05">
            {{ $t('message.mash') }}
          </li>
          <!-- 购买数量 -->
          <li>
            {{ $t('message.PurchaseQuantity') }}
          </li>
          <!-- 问题产品状态 -->
          <li>
            {{ $t('message.problemProductStatus') }}
          </li>
          <!-- 不良产生时间 -->
          <li>
            {{ $t('message.DefectOccurrenceTime') }}
          </li>
          <!-- 不良数量 -->
          <li>
            {{ $t('message.NumberOfDefects') }}
          </li>
          <!-- 不良说明 -->
          <li class="flex2">
            {{ $t('message.DefectDescription') }}
          </li>
          <!-- 不良图片 -->
          <li class="flex3">
            {{ $t('message.DefectImage') }}
          </li>
          <!-- 处理决策 -->
          <li v-if="type > 1">
            {{ $t('message.HandlingDecision') }}
          </li>
          <!-- 处理完成时间 -->
          <li v-if="type > 2">
            {{ $t('message.HandlingCompletionTime') }}
          </li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <!-- 订单号 -->
          <li class="flex2">
            <router-link :to="'/oederDetai?order_sn=' + item.order_sn" target="_blank" class="a-link">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番号 -->
          <li class="flex05">
            {{ item.sorting }}
          </li>

          <!-- 购买数量 -->
          <li>
            {{ item.confirm_num ? item.confirm_num : item.offer_num_bak }}
          </li>
          <!-- 问题产品状态 -->
          <li>
            {{ item.status_name ? item.status_name : item.problem_goods_status_name }}
          </li>
          <!-- 不良产生时间 -->
          <li>
            {{ item.created_at }}
          </li>
          <!-- 不良数量 -->
          <li>
            {{ item.num }}
          </li>
          <!-- 不良说明 -->
          <li class="flex2">
            {{ item.description_translate }}
          </li>
          <!-- 不良图片 -->
          <li class="flex3">
            <div>
              <el-image style="width:80px;height: 80px;border-radius: 6px;" :src="pic.image"
                v-for="(pic, picIndex) in item.problem_goods_image" :key="picIndex" :preview-src-list="[pic.image]">
              </el-image>
            </div>
          </li>
          <!-- 处理决策 -->
          <li v-if="type > 1">
            {{ item.client_deal }}
          </li>
          <!-- 处理完成时间 -->
          <li v-if="type > 2">
            {{ item.p_deal_at }}
          </li>
        </ul>
        <div class="nodata" v-if="list == false">暂无数据</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      list: [],
      type: '',
    };
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 30px;

  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex2 {
    flex: 2;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 42px;
  }

  ul {
    background-color: #fff;
    min-height: 100px;
    padding: 5px 0;

    .template {
      display: flex;
      line-height: 36px;
    }

    /deep/.el-textarea__inner {
      height: 110px !important;
      width: 100% !important;
    }

    /deep/.el-upload-dragger {
      width: auto;
      height: auto;
      border: none;
    }

  }

  .file {
    width: 100%;

    .item {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      a {
        margin-right: 12px;
        flex: 1;
      }

      .el-icon-error {
        cursor: pointer;
        font-size: 16px;
        color: #B4272B;
        ;
      }
    }
  }

  .pic-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .img {
      position: relative;
      width: 50px;
      margin-right: 5px;

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:nth-last-child(1) {
            margin-left: 10px;
          }
        }
      }

      video {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }

  .bgc {
    background-color: rgba(250, 205, 145, 0.58);
  }
}

.nodata {
  text-align: center;
  padding: 30px;
  font-size: 20px;
}

.operation {
  margin-top: 24px;
}
</style>